/* unplugin-vue-components disabled */import { render } from "./product_main.vue?vue&type=template&id=25fdc31a&scoped=true"
import script from "./product_main.vue?vue&type=script&lang=js"
export * from "./product_main.vue?vue&type=script&lang=js"

import "./product_main.vue?vue&type=style&index=0&id=25fdc31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fdc31a"]])

export default __exports__